export function catColors(cat) {
  if (cat === 'Video') return { from: 'rgba(99,102,241,.35)', to: 'rgba(167,139,250,.18)', ring: 'rgba(99,102,241,.45)', label: '#A5B4FC' };
  if (cat === 'Text')  return { from: 'rgba(16,185,129,.30)', to: 'rgba(16,185,129,.10)',  ring: 'rgba(16,185,129,.4)',  label: '#6EE7B7' };
  return                      { from: 'rgba(255,126,103,.35)',to: 'rgba(255,77,141,.18)',  ring: 'rgba(255,77,141,.45)', label: '#FFC2B5' };
}
